import {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
} from "../api/request";

export const getCustomers = () => {
  return getRequest("/customers");
};

export const getCustomerAuditAPI = ({ customerId }) => {
  return getRequest(`/customers/${customerId}/audit`);
};
export const getCustomersStats = () => {
  return getRequest("/customers/stats");
};
export const getCustomerById = (id) => {
  return getRequest(`/customers/${id}`);
};

export const createCustomer = (data) => {
  return postRequest("/customers", data);
};

export const updateCustomer = (id, data) => {
  return putRequest(`/customers/${id}`, data);
};

export const deleteCustomer = (id) => {
  return deleteRequest(`/customers/${id}`);
};
